import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
  getSbatGroupsSuperBatchIds,
  selectedBulkUpdateSbatGroupsSelector,
  setRemoveSuperBatchesModalStage,
  resetSbatGroupBulkUpdate,
  useBulkRemoveSuperBatchesMutation,
  VIEW_SCHEDULE_PAGE_TRACKINGS,
} from 'features/classCreation';
import analytics from 'utils/analytics';
import GlobalLoader from 'components/GlobalLoader';

function BulkRemoveSuperBatchesButton({ disabled, selectedSuperBatches }) {
  const dispatch = useDispatch();
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);
  const [bulkRemoveSuperBatches, { isSuccess, error, isLoading: isRemoving }] =
    useBulkRemoveSuperBatchesMutation();

  useEffect(() => {
    if (isSuccess) {
      batch(() => {
        dispatch(
          setRemoveSuperBatchesModalStage(
            BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.notOpen
          )
        );
        dispatch(resetSbatGroupBulkUpdate());
      });
      cogoToast.success('Selected batches are removed successfully!');
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  const handleBulkRemoveSuperBatches = useCallback(() => {
    const superBatchIds = selectedSuperBatches.map(
      (superBatch) => superBatch.value
    );

    const sbatGroupIds = Object.keys(selectedSbatGroups);
    const previousSuperBatchIds =
      getSbatGroupsSuperBatchIds(selectedSbatGroups);

    analytics.click({
      click_type: VIEW_SCHEDULE_PAGE_TRACKINGS.bulkRemoveSuperBatches,
      custom: {
        class_ids: sbatGroupIds,
        num_of_classes: sbatGroupIds.length,
        previous_super_batch_ids: previousSuperBatchIds,
        removed_super_batch_ids: superBatchIds,
      },
    });
    bulkRemoveSuperBatches({
      sbatGroupIds: sbatGroupIds,
      superBatchIds: superBatchIds,
    });
  }, [bulkRemoveSuperBatches, selectedSbatGroups, selectedSuperBatches]);

  return (
    <>
      <GlobalLoader isVisible={isRemoving} />
      <Tappable
        className="btn btn-primary m-t-s"
        onClick={handleBulkRemoveSuperBatches}
        disabled={disabled || isRemoving}
      >
        Remove Batches
      </Tappable>
    </>
  );
}

export default BulkRemoveSuperBatchesButton;
